import { Component, Renderer } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../../../core/abstract-form-component';
import { createDialogValidationMessages, getCreateDialogControlsConfig } from './create.dialog.form';
import { CreateDialogPersonalStateService } from './create.dialog.state.service';
import { CommunicationsHttpService } from '../../../../services/communications/communications.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { CommunicationsHttpUtil } from '../../communications/communications.util';
import { AuthUtil } from '../../../../utils/auth.utils';
import { Router } from '@angular/router';

@Component({
  moduleId: module.id,
  selector: 'bft-create-dialog-personal',
  templateUrl: 'create.dialog.component.html',
  styleUrls: ['create.dialog.component.css'],
  providers: []
})

export class CreateQuestComponent extends AbstractFormComponent {

  chatTypeList = [{label: 'Изменение контактной информации', value: '3'}];
  model = {
    chatType: this.chatTypeList[0].value,
    chatTheme: '',
    chatMessage: '',
    lawInstanceId: '0',
  };
  attachment;
  displayDialog: boolean = false;
  loading: boolean = false;
  errorMessage = '';
  successMessage = '';

  isAttached = false;

  constructor(private createDialogPersonalStateService: CreateDialogPersonalStateService,
              private formBuilder: FormBuilder,
              private communicationsHttpService: CommunicationsHttpService,
              private authUtil: AuthUtil,
              private router: Router,
              private renderer: Renderer,
  ) {
    super();

    this.createDialogPersonalStateService.handleDialogStatus().subscribe(data => {
      this.displayDialog = data.display;
      this.isAttached = false;
      this.attachment = '';
      this.errorMessage = '';
      this.form.reset();
      this.model = {
        chatType: this.chatTypeList[0].value,
        chatTheme: '',
        chatMessage: '',
        lawInstanceId: '0',
      };
      this.form.patchValue(this.model);
    });

  }

  buildForm(): FormGroup {
    return this.formBuilder.group(getCreateDialogControlsConfig(this.model, this.formBuilder));
  }

  getValidationMessages(): {} {
    return createDialogValidationMessages;
  }

  submit() {
    this.loading = true;
    delete this.errorMessage;
    delete this.successMessage;

    let data = {
      securityToken: StorageUtil.getToken(),
      chatType: this.form.value.chatType,
      chatTheme: this.form.value.chatTheme,
      chatMessage: this.form.value.chatMessage,
      lawInstanceId: this.model.lawInstanceId,
      attachment: this.attachment,
    };

    let requestParams = CommunicationsHttpUtil.prepareParamsCreateDialog(data);
    this.communicationsHttpService.createChat(requestParams).subscribe(
      success => {
        if (success) {
          this.loading = false;
          //if(success.json().response) {

            this.router.navigate(['communications']);

            this.displayDialog = false;
            this.isAttached = false;
            this.attachment = '';
          //}

            this.authUtil.checkErrorResponse(success.json());
        }
      },
      error => {
        this.errorMessage = 'Произошла ошибка.';
        this.loading = false;
      },
      () => {
        this.loading = false;
      });
  }

  close($event) {
    $event.preventDefault();
    this.displayDialog = false;
    this.attachment = '';
  }

  triggerSetAttachment($event) {
    this.isAttached = !!$event.attachment;
    this.attachment = $event.attachment;
  }

  findAncestor (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  }

  onFocus($event) {
    let element = this.findAncestor($event.target, 'topic-hold');
    this.renderer.setElementClass(element, 'focus', true);
  }

  onBlur($event) {
    let element = this.findAncestor($event.target, 'topic-hold');
    this.renderer.setElementClass(element, 'focus', false);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/personal/create-quest/create.dialog.component.ts